import React from "react";
import { useTranslate } from "@refinedev/core";
import { Chip } from "@mui/material";
import type { EventType } from "../types/events";
import { getEventChipColor } from "../constants/eventColors";

interface EventTypeChipProps {
  eventType: EventType;
  size?: "small" | "medium";
}

const LABEL_KEYS: Record<EventType, { key: string; fallback: string }> = {
  alert: { key: "history.type.alert", fallback: "Alert" },
  forbidden_zone: { key: "history.type.forbiddenZone", fallback: "Zone" },
  journey: { key: "history.type.journey", fallback: "Journey" },
};

export const EventTypeChip: React.FC<EventTypeChipProps> = ({
  eventType,
  size = "small",
}) => {
  const translate = useTranslate();
  const { key, fallback } = LABEL_KEYS[eventType];

  return (
    <Chip
      label={translate(key, fallback)}
      size={size}
      sx={{
        ...getEventChipColor(eventType),
        fontWeight: 600,
        fontSize: size === "small" ? "0.75rem" : "0.875rem",
      }}
    />
  );
};
